<template>
	<div class="view-content__wrapper">
		<div class="view-content">
			<div class="mb-6 headline-1">
				{{ $t("setup_account.identification") }}
			</div>
			<Alert v-if="getError" />
			<div>
				<e-tabs
					class="mb-6"
					:value="0"
					:grow="true"
					:small="false"
					:large="false">
					<e-tab
						v-for="loginMethod in primaryLoginMethods"
						:key="loginMethod"
						class="body-3 pl-0 pr-0"
						@click="navigate(loginMethod)">
						{{ $t("menu-items." + loginMethod) }}
					</e-tab>
					<e-menu
						bottom=""
						minWidth="160"
						nudgeBottom="8"
						offsetY="">
						<template #activator="{on, attrs}">
							<e-tab
								v-bind="attrs"
								activator
								v-on="on">
								<e-icon>
									icon-chevron-down
								</e-icon>
							</e-tab>
						</template>
						<e-menu-list>
							<e-menu-list-item
								v-for="loginMethod in secondaryLoginMethods"
								:key="loginMethod"
								class="body-2"
								@click="navigate(loginMethod)">
								{{ $t("menu-items." + loginMethod) }}
							</e-menu-list-item>
						</e-menu-list>
					</e-menu>
				</e-tabs>
			</div>
			<transition
				name="fade"
				mode="out-in">
				<Password
					v-if="activeItem == 'password'"
					:register="true" />
				<Mobile
					v-if="activeItem == 'mobile_id'"
					:register="true" />
				<Smart
					v-if="activeItem == 'smart_id'"
					:register="true" />
				<Har
					v-if="activeItem == 'har_id'"
					:register="true" />
				<Card
					v-if="activeItem == 'id_card'"
					:register="true" />
				<XId
					v-if="activeItem == 'x_id'"
					:register="true" />
			</transition>
			<div class="mt-4 text-center d-flex align-center justify-center">
				<span class="subhead-2 greybase-text mr-2">{{ $t('menu-items.already_have_an_account') }}</span>
				<e-button
					variant="link"
					small=""
					:block="false"
					:to="'/' + this.$i18n.locale">
					{{ $t("password_login.login") }}
				</e-button>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src

import Password from "@/components/Password.vue";
import Mobile from "@/components/Mobile.vue";
import Smart from "@/components/Smart.vue";
import Har from "@/components/Har.vue";
import Card from "@/components/Card.vue";
import XId from "@/components/XId.vue";

import Alert from "@/components/Alert.vue";
import { mapState, mapGetters } from 'vuex';
import { getEnv } from "../env";
export default {
	components: {
		Password,
		Mobile,
		Smart,
		Har,
		Card,
		XId,
		Alert,
	},
	data () {
		return {
			activeItem: "password",
			primaryLoginMethods: getEnv('VUE_APP_FRONTEND_PRIMARY_LOGIN_METHODS').split(", "),
			secondaryLoginMethods: getEnv('VUE_APP_FRONTEND_SECONDARY_LOGIN_METHODS').split(", "),
		};
	},
	computed: {
		...mapState([
			'mobileView',
		]),
		...mapGetters([
			'getError',
		]),
	},
	mounted () {
		if(this.mobileView){
			//remove id-card login method in mobile view
			this.primaryLoginMethods = this.primaryLoginMethods.filter(e => e !== 'id_card')
		}	
		else{
			//if not mobile view, take login methods from env
			this.primaryLoginMethods = getEnv('VUE_APP_FRONTEND_PRIMARY_LOGIN_METHODS').split(", ")
		}
	},
	methods: {
		navigate (item) {
			this.activeItem = item;
			this.$store.commit("showError", false);
		},
	},
};
</script>
